module.exports = __webpack_public_path__ + "static/media/img_dance12.017343bd.png";